import { render } from "./Blank.vue?vue&type=template&id=772c92b6"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/plaintes.getourvoice.com/releases/72929466/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__